<template>
  <div>
    <v-card class>
      <router-link :to="to" class="nolink secondary--text">
        <v-container class="py-0">
          <v-row class>
            <v-col cols="4" class="pt-0 pb-0 text-center">
              <v-avatar
                :color="color"
                tile
                :size="86"
                class="icon-box hover-tile"
              >
                <v-icon x-large dark>{{ icon }}</v-icon>
              </v-avatar>
            </v-col>

            <v-col cols="8" class="text-right pb-0">
              <h5 class="font-weight-light">My Portal Name</h5>

              <h4
                style="cursor: text"
                contenteditable="true"
                @click="editName"
                ref="section-title"
                @blur="updateName"
                @keypress.enter="$event.target.blur"
              >
                {{ item.name }}
              </h4>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-container class="py-2" style="line-height: 1rem">
          <v-row>
            <v-col cols="6" class="py-0">
              <span class="caption">Created</span>
            </v-col>
            <v-col cols="6" class="py-0 text-right">
              <span class="caption font-weight-bold">{{
                item.date_added | fromNow
              }}</span>
            </v-col>
            <v-col cols="6" class="py-0">
              <span class="caption">Visits</span>
            </v-col>
            <v-col cols="6" class="py-0 text-right">
              <span class="caption font-weight-bold">{{ item.visits }}</span>
            </v-col>
            <v-col cols="6" class="py-0">
              <span class="caption">Applicants</span>
            </v-col>
            <v-col cols="6" class="py-0 text-right">
              <span class="caption font-weight-bold">{{
                item.applicants
              }}</span>
            </v-col>
          </v-row>
        </v-container>
      </router-link>

      <template>
        <v-card-actions class="grey lighten-4" v-if="$slots.actions">
          <slot name="actions" />
        </v-card-actions>
      </template>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["item", "to"],
  computed: {
    icon() {
      return this.item.icon || "fa-desktop";
    },
    color() {
      if (this.item.type === "Event") {
        return "green";
      }
      if (this.item.type === "Business") {
        return "black";
      }
      return "blue";
    },
  },
  methods: {
    editName(ev) {
      ev.preventDefault();
    },
    updateName() {
      if (!this.$refs["section-title"].innerText) {
        this.$refs["section-title"].innerText = this.item.name;
        return alert("Portal name required");
      }
      if (this.$refs["section-title"].innerText !== this.item.name) {
        this.item.name = this.$refs["section-title"].innerText;
        this.$emit("change", this.item);
      }
    },
  },
};
</script>

<style>
.hover-up {
  position: relative;
}

.icon-box {
  transform: translateY(-25px);
  border-radius: 10px;
}
.icon-box:hover {
  transform: translateY(-30px);
}

.bottom-box,
.top-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.top-box {
  z-index: 10;
}
.bottom-box {
  z-index: 5;
}

.top-box {
  -webkit-transition: 0.2s ease;
  -moz-transition: 0.2s ease;
  -o-transition: 0.2s ease;
  transition: 0.2s ease;
}

.hover-up:hover .top-box {
  transform: translateY(-50px);
  -webkit-box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
  -moz-box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
  box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
}
</style>